import { SubsectionGroup } from '@sleepstation/components'
import { VList } from '@sleepstation/components-layouts'
import { LAYOUT_SPACING } from '@sleepstation/const'
import { renderList } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import TranscriptionItem from './TranscriptionItem'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Transcription = ({ title, transcription }) => (
  <SubsectionGroup
    title={title}
    spacing={[
      LAYOUT_SPACING.MEDIUM,
      LAYOUT_SPACING.LARGE,
      LAYOUT_SPACING.LARGE,
      LAYOUT_SPACING.MEDIUM,
    ]}
  >
    <VList spacing={LAYOUT_SPACING.LARGE}>
      {renderList(
        ({ timecode, body }) => (
          <TranscriptionItem timecode={timecode} body={body} />
        ),
        transcription
      )}
    </VList>
  </SubsectionGroup>
)

Transcription.propTypes = {
  title: PropTypes.string.isRequired,
  transcription: PropTypes.array.isRequired,
}

export default Transcription
